export enum AddModeratorType {
  Search = 1,
  Invite,
}
